<div aria-labelledby="mobile-footer-sheet-title" class="mobile-footer-sheet" role="region">
  <div aria-hidden="true" class="mobile-footer-sheet__handle"></div>

  <header class="mobile-footer-sheet__header">
    <div>
      <h2 id="mobile-footer-sheet-title">{{ title }}</h2>
      <p>{{ description }}</p>
    </div>
    <button (click)="close()" aria-label="메뉴 닫기" class="mobile-footer-sheet__close" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <nav aria-label="세부 서비스" class="mobile-footer-sheet__list">
    @for (link of links; track link.name; let index = $index) {
      @if (link.group && (index === 0 || links[index - 1].group !== link.group)) {
        <p class="mobile-footer-sheet__group">{{ link.group }}</p>
      }
      <button (click)="clickLink(link)" class="mobile-footer-sheet__link" type="button">
        <span aria-hidden="true" class="mobile-footer-sheet__icon">
          <img *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" alt="" draggable="false">
          <lord-icon
            *ngIf="!link.icon.endsWith('.svg')"
            [src]="link.icon"
            colors="primary:#0b57d0,secondary:#0b57d0"
            trigger="hover">
          </lord-icon>
        </span>
        <span>{{ link.name }}</span>
        <mat-icon aria-hidden="true" class="mobile-footer-sheet__chevron">chevron_right</mat-icon>
      </button>
    }
  </nav>
</div>
